import React, {useState} from "react";
import {Autocomplete, IconButton, TextField, Typography} from "@mui/material";
import {AddCircle as AddIcon, RemoveCircle as RemoveIcon} from "@mui/icons-material";
import {arrays, forms, objects, strings} from "@atttomyx/shared-utils";
import {confirm} from "@atttomyx/react-utils";
import "./tagsForm.css";

const TagsForm = (props) => {
    const { options, data, onChange : onSync } = props;
    const [ tag, setTag ] = useState(null);

    const addTag = (tag) => {
        const modified = objects.deepCopy(data);
        const tags = modified.tags;

        if (!arrays.contains(tags, tag)) {
            arrays.addTo(tags, tag);

            modified.tags = tags;
            onSync(modified);
        }

        setTag(null);
    };

    const removeTag = (tag) => {
        const modified = objects.deepCopy(data);
        const tags = modified.tags;

        if (arrays.contains(tags, tag)) {
            arrays.removeFrom(tags, tag);

            modified.tags = tags;
            onSync(modified);
        }
    };

    return <div className="tags-form">
        {data.tags.map((tag, index) => (
            <div key={index} className="tag">
                <IconButton
                    color="secondary"
                    title="Remove"
                    onClick={() => confirm.confirmDelete(tag, () => removeTag(tag))}
                >
                    <RemoveIcon/>
                </IconButton>
                <Typography className="truncated" component="span">
                    {tag}
                </Typography>
            </div>
        ))}
        <div className="field top-margin">
            <Autocomplete
                options={options}
                inputValue={forms.sanitizeValue(tag)}
                value={null}
                noOptionsText={strings.isNotBlank(tag)
                    ? <>
                        <IconButton
                            title="Add"
                            color="primary"
                            onClick={() => addTag(tag)}
                        >
                            <AddIcon/>
                        </IconButton>
                        <Typography
                            component="span"
                            color="text.primary"
                        >
                            {tag}
                        </Typography>
                    </>
                    : "Type to add a tag..."}
                getOptionDisabled={option => arrays.contains(data.tags, option)}
                isOptionEqualToValue={(option, value) => value && strings.equalsIgnoreCase(option, value)}
                renderInput={params =>
                    <TextField
                        label="Tag"
                        {...params}
                    />}
                onInputChange={(event, value, reason) => {
                    if (reason !== "reset") {
                        setTag(value);
                    }
                }}
                onChange={(event, value) => addTag(value)}
            />
        </div>
    </div>
};

export default TagsForm;
